function PermissionIcon({ slug, onClick }) {
    if (slug.includes("view")) {
        return <i className="fas fa-eye item-icon" onClick={onClick}></i>;
    } else if (slug.includes("create") || slug.includes("add")) {
        return <i className="fas fa-plus item-icon" onClick={onClick}></i>;
    } else if (slug.includes("import")) {
        return <i className="fas fa-upload item-icon" onClick={onClick}></i>;
    } else if (slug.includes("update")) {
        return <i className="fas fa-edit item-icon" onClick={onClick}></i>;
    } else if (slug.includes("delete")) {
        return <i className="fas fa-trash item-icon" onClick={onClick}></i>;
    } else if (slug.includes("expel")) {
        return <i className="fas fa-ban item-icon" onClick={onClick}></i>;
    } else if (slug.includes("export")) {
        return <i className="fas fa-download item-icon" onClick={onClick}></i>;
    } else if (slug.includes("change_password")) {
        return <i className="fas fa-exchange-alt item-icon" onClick={onClick}></i>;
    } else if (slug.includes("change_company")) {
        return <i className="fas fa-sync item-icon" onClick={onClick}></i>;
    } else if (slug.includes("run")) {
        return <i className="fas fa-play item-icon" onClick={onClick}></i>;
    } else if (slug.includes("lock")) {
        return <i className="fas fa-lock item-icon" onClick={onClick}></i>;
    } else if (slug.includes("erase")) {
        return <i className="fas fa-eraser item-icon" onClick={onClick}></i>;
    }
    return null;
}

export default PermissionIcon;